export class IncomesAvailableService {
  constructor (API, Auth, ItCache) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
    this.ItCache = ItCache;
  }

  checkIncomesAvailable() {
    return this.ItCache.get("incomesAvailable" , () => {
      return this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/teams/has-incomes-available'
      });
    });
  }

  getIncomesAvailable() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/teams/incomes-available'
    });
  }
}
